import { gql } from "@apollo/client";

export const CREATE_DELEGATION = gql`
  mutation createDelegation(
    $Year_ID: Float!
    $User_ID: Float!
    $Alternate_User_ID: Float!
    $Start_Date: String!
    $End_Date: String!
    $Comments: String!
    $Has_Consented: String!
    $Status: String!
    $Vote_ID: Float
    $LG_Vote_ID: Float
    $Created_By: String!
    $Modified_By: String!
  ) {
    createDelegation(
      data: {
        Year_ID: $Year_ID
        User_ID: $User_ID
        Alternate_User_ID: $Alternate_User_ID
        Start_Date: $Start_Date
        End_Date: $End_Date
        Comments: $Comments
        Has_Consented: $Has_Consented
        Status: $Status
        Vote_ID: $Vote_ID
        LG_Vote_ID: $LG_Vote_ID
        Created_By: $Created_By
        Modified_By: $Modified_By
      }
    ) {
      Report_Delegation_ID
      Year_ID
      Vote_ID {
        Vote_ID
        Vote_Code
        Vote_Name
      }
      LG_Vote_ID
      User_ID
      Alternate_User_ID
      Start_Date
      End_Date
      Comments
      Has_Consented
      Status
      Created_Date
      Modified_Date
      Created_By
      Modified_By
    }
  }
`;

export const UPDATE_DELEGATION = gql`
  mutation updateDelegation($id: Float!, $data: UpdateReportDelegationInput!) {
    updateDelegation(id: $id, data: $data) {
      Report_Delegation_ID
      Status
      Modified_By
      Modified_Date
    }
  }
`;

export const DELETE_DELEGATION = gql`
  mutation removeDelegation($id: Float!) {
    removeDelegation(id: $id) {
      Report_Delegation_ID
      Status
    }
  }
`;